import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer id="contact" className="bg-ink text-mist py-14">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center">
          <div className="flex items-center justify-center gap-2.5 mb-4">
            <span className="av-wave" aria-hidden="true" style={{ height: 20 }}>
              <span /><span /><span /><span /><span /><span /><span />
            </span>
            <span className="text-xl font-bold uppercase tracking-[0.14em] text-white">Alfred Voice</span>
          </div>
          <p className="text-mist mb-6 max-w-xl mx-auto">
            Inbound and outbound voice AI — Alfred answers every call around the clock, and makes the
            calls your team never gets to.
          </p>
          <p className="text-mist mb-6">
            Contact: <a href="mailto:brian@alfredvoice.com" className="text-brass hover:text-white">brian@alfredvoice.com</a>
            {' '}· <a href="tel:3462580006" className="text-brass hover:text-white">(346) 258-0006</a>
          </p>

          {/* Areas we cover. Mirrors the AREAS grid on the homepage — a footer link on
              every page is what gives these vertical pages internal links from the whole
              site rather than from one section of one page. Keep the two in sync. */}
          <div className="mb-8">
            <div className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-sm">
              <Link to="/transportation" className="text-mist hover:text-white transition-colors">Transportation</Link>
              <span className="text-white/25">•</span>
              <Link to="/industries/dispatchers" className="text-mist hover:text-white transition-colors">Dispatch Services</Link>
              <span className="text-white/25">•</span>
              <Link to="/industries/brokers" className="text-mist hover:text-white transition-colors">Freight Brokerages</Link>
              <span className="text-white/25">•</span>
              <Link to="/industries/pest-control" className="text-mist hover:text-white transition-colors">Pest Control</Link>
              <span className="text-white/25">•</span>
              <Link to="/industries/property-management" className="text-mist hover:text-white transition-colors">Property Management</Link>
              <span className="text-white/25">•</span>
              <Link to="/industries/call-centers" className="text-mist hover:text-white transition-colors">Call Centers</Link>
            </div>
          </div>

          {/* Resources + legal */}
          <div className="mb-6">
            <div className="flex flex-wrap justify-center gap-4 text-sm">
              {/* /drivers is the driver-facing side of the marketplace. Linked
                  here rather than in the header so the top nav stays aimed at
                  carriers — but it must be linked SOMEWHERE: an orphan page with
                  no internal links earns no crawl priority and no link equity. */}
              <Link to="/drivers" className="text-mist hover:text-white transition-colors">For Drivers</Link>
              <span className="text-white/25">•</span>
              <a href="https://alfredcc.relaywork.co/publicdocs" target="_blank" rel="noopener noreferrer" className="text-mist hover:text-white transition-colors">Documentation</a>
              <span className="text-white/25">•</span>
              <Link to="/support" className="text-mist hover:text-white transition-colors">Support</Link>
              <span className="text-white/25">•</span>
              <Link to="/contact" className="text-mist hover:text-white transition-colors">Contact</Link>
              <span className="text-white/25">•</span>
              <a href="/privacy" className="text-mist hover:text-white transition-colors">Privacy Policy</a>
              <span className="text-white/25">•</span>
              <a href="/terms" className="text-mist hover:text-white transition-colors">Terms of Service</a>
            </div>
          </div>

          <div className="h-px bg-white/10 my-6" />
          <p className="text-mist/70 text-sm">
            &copy; 2026 Alfred Voice — a Relay Work product, Mule Works Inc. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
